import schema, { generateType } from './Schema';
export const ShopifyConfig = generateType(schema.getModel('shopifyConfig'));
//# sourceMappingURL=ShopifyConfigModel.js.map